module.exports = __webpack_public_path__ + "img/copy-icon-black.e2859231.svg";